import { endEditingAction } from '../designerReducer';

export const cancelDesign = () => dispatch => {
  dispatch(endEditingAction());
};
